import React from "react";
import content from "../data/results/2014content.json";
import resultData from "../data/2014data.json";
import ResultsPage from "./ResultsPage";

const Results2014 = () => <ResultsPage content={content} resultData={resultData} />;

export default Results2014;
